import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import UserProjectListTable, { LIST_HEADERS, TModalProps } from './_components/users-table.component'
import { CurecallButton, ECurecallButtonAppearance } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import {
  useCurrentProject,
  WithPermission,
} from 'src/providers/current-project.provider'
import {
  EPermissionGrantActions,
  EPermissionGrantSubjects,
  TPermission,
} from 'src/pages/configuration/permissions/_components/permissions.type'
import PageTitle from 'src/components/page-title/page-title.component'
import { useQuery } from '@tanstack/react-query'
import { ProjectService } from 'src/services/project.service'
import AddOrUpdateUserModal from './_components/add-or-update-user-modal.component'
import DeleteUserModal from './_components/delete-user-modal.component'

export default function UserProjectListPage() {
  const { t } = useTranslation()
  const { project } = useCurrentProject()

  const [modalProps, setModalProps] = useState<TModalProps>(undefined)
  const [orderBy, setOrderBy] = useState<{ key: (typeof LIST_HEADERS)[number]; descOrder: boolean }>({
    key: 'user',
    descOrder: false,
  })

  const {
    isLoading: isProjectPermissionListLoading,
    error: getProjectPermissionListError,
    data: projectPermissionList,
  } = useQuery({
    queryKey: ['permissions'],
    queryFn: () => ProjectService.getPermissions(project.id),
  })

  if (getProjectPermissionListError) {
    return <ErrorQueryHandler error={getProjectPermissionListError} />
  }

  if (isProjectPermissionListLoading) {
    return <div className="loading" />
  }

  return (
    <WithPermission
      requiredSubject={EPermissionGrantSubjects.USER_MANAGEMENT}
      requiredAction={EPermissionGrantActions.GET}
      onFailure={'permission-error-component'}
    >
      <div className="c-flex c-flex-col c-gap-4">
        <div className="c-relative c-flex c-justify-between c-items-center">
          <PageTitle>{t('pages.users-page.title-project-users')}</PageTitle>
          <CurecallButton
            className="c-absolute c-right-0"
            appearance={ECurecallButtonAppearance.SECONDARY}
            onClick={() => setModalProps({ mode: 'POST', UserProject: undefined })}
          >
            {t('pages.users-page.add-user')}
          </CurecallButton>
        </div>

        <UserProjectListTable
          setModalProps={setModalProps}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          projectPermissionList={projectPermissionList as TPermission[]}
        />

        <AddOrUpdateUserModal
          modalProps={modalProps}
          setModalProps={setModalProps}
          projectPermissionList={projectPermissionList as TPermission[]}
        />

        <DeleteUserModal modalProps={modalProps} setModalProps={setModalProps} />
      </div>
    </WithPermission>
  )
}
